import $ from 'jquery'
import config from './config'
import { ApplicationObservableInstance } from './observables/application-observable'
import AppProps from './app-props'


export default (() => {
  const checksum = () => ApplicationObservableInstance.orderModel.checksum
  const getOrderId = () => ApplicationObservableInstance.orderModel.externalOrderId

  const cart = {
    add: data => $.ajax({
      method: 'POST',
      url: '/order-processing/rest/checkout/cart/line-items',
      headers: { Accept: 'application/json;q=0.9;v=1' },
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify([data]),
    }),
    delete: item => $.ajax({
      method: 'PUT',
      url: `/order-processing/rest/checkout/cart/${getOrderId()}/line-items`,
      headers: { Accept: 'application/json;q=0.9;v=1' },
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        reiRefId: item.reiRefId,
        quantity: item.availability ? item.availability.quantity : 0,
        sku: item.sku,
        lineItemId: item.lineItemId,
      }),
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////
  // StoresWebService                                                                        //
  // - GET /stores Returns a list of retail stores which match this criteria: visible (i.e.  //
  // - GET /stores/{storeNumber} Gets a single store with the given store number.            //
  // - DELETE /stores/cache Clears all Retail Store caches.                                  //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const stores = {
    get: storeNumber => $.get({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `/retail-stores/stores/${storeNumber}`,
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////
  // CustomerInfoWebService                                                                  //
  // - GET /{config.API_URL}/orders/{externalOrderId}/customer-info Return customer info for //
  //  a given order                                                                          //
  // - PUT /{config.API_URL}/orders/{externalOrderId}/customer-info Update customer info for //
  //  a given order                                                                          //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const customer = {
    // TODO: Add the GET method
    put: data => $.ajax({
      type: 'PUT',
      headers: { checksum: checksum(), Accept: 'application/json;q=0.9;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/customer-info`,
      data,
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////
  // TendersWebService                                                                       //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/tenders Return an order's tenders             //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/tenders Replaces all an order's tenders       //
  // - POST /{config.API_URL}/orders/{ORDER_ID}/tenders Create a tender for an order         //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/tenders/{tenderId} Return info about a single //
  //  tender                                                                                 //
  // - DELETE /{config.API_URL}/orders/{ORDER_ID}/tenders/{tenderId} Delete a tender from a  //
  //  given order                                                                            //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const tenders = {
    get: () => $.get({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/tenders`,
    }),
  }

  const tender = {
    post: data => $.post({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/tenders`,
      data,
    }),
    get: id => $.get({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/tenders/${id}`,
    }),
    delete: id => $.ajax({
      type: 'DELETE',
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      url: `${config.API_URL}/orders/${getOrderId()}/tenders/${id}`,
    }),
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // MemberInformationWebService                                                             //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/member-information Return an order's member   //
  //  information                                                                            //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/member-information Update an order's member   //
  //  information                                                                            //
  // //////////////////////////////////////////////////////////////////////////////////////////

  // Unused

  // //////////////////////////////////////////////////////////////////////////////////
  // OrderSubmitWebService                                                           //
  // - POST /{config.API_URL}/orders/{ORDER_ID}/submit-request Submit an order       //
  //   NOTE: this also handles the submit for Apple Pay orders                       //
  // //////////////////////////////////////////////////////////////////////////////////

  const submit = {
    post: data => $.post({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/submit-request`,
      data,
    }),
  }


  // ////////////////////////////////////////////////////////////////////
  // BillingAddressWebService                                          //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/billing-address GET     //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/billing-address PUT     //
  // ////////////////////////////////////////////////////////////////////

  const billingAddress = {
    put: data => $.ajax({
      type: 'PUT',
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/billing-address`,
      data,
    }),
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // CouponWebService                                                                        //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/coupons Return an order's coupons             //
  // - POST /{config.API_URL}/orders/{ORDER_ID}/coupons Create coupons for an order          //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/coupons Update an order's coupons             //
  // - DELETE /{config.API_URL}/orders/{ORDER_ID}/coupons/{couponId} Delete a coupon from a  //
  //  given order                                                                            //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/coupons/{couponId} Return an order's coupon   //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/coupons/{couponId} Update a coupon in a given //
  //  order                                                                                 //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const coupons = {
    get: () => $.get({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json;v=1',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/coupons`,
    }),
    post: data => $.post({
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/coupons`,
      data,
    }),
  }

  const coupon = {
    delete: id => $.ajax({
      type: 'DELETE',
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      url: `${config.API_URL}/orders/${getOrderId()}/coupons/${encodeURIComponent(id)}`,
    }),
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // OrdersWebService                                                                        //
  // - POST /{config.API_URL}/orders/{ORDER_ID} Create an order from a given cart            //
  // - REQUEST /{config.API_URL}/orders/order-request Loads an order                         //
  // - IDENTIFIERS /{config.API_URL}/orders/identifiers-request Load order ids               //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const order = {
    audit: (options) => {
      const alwaysAuditWithEADs = AppProps.get('checkout.audit.use.by.ead', false)
      // eslint-disable-next-line no-param-reassign
      if (alwaysAuditWithEADs) options = { eadIncluded: true }

      return $.post({
        headers: { checksum: checksum(), Accept: 'application/json;q=0.9;v=2' },
        contentType: 'application/json',
        dataType: 'json',
        url: `${config.API_URL}/orders/${getOrderId()}/audit-request`,
        data: JSON.stringify(options),
      })
    },

    identifiers: () => $.get({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/identifiers-request`,
    }),

    patch: data => $.ajax({
      type: 'PUT',
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}`,
      data: JSON.stringify(data),
    }),

    notes: {
      post: data => $.post({
        headers: { checksum: checksum(), Accept: 'application/json;v=1' },
        contentType: 'application/json',
        dataType: 'json',
        url: `${config.API_URL}/orders/${getOrderId()}/order-notes`,
        data: JSON.stringify(data),
      }),
      delete: noteType => $.ajax({
        type: 'DELETE',
        headers: { checksum: checksum(), Accept: 'application/json;v=1' },
        contentType: 'application/json',
        dataType: 'json',
        url: `${config.API_URL}/orders/${getOrderId()}/order-notes/${noteType}`,
      }),
    },
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // LineItemsWebService                                                                     //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/line-items Return an order's line items       //
  // - POST /{config.API_URL}/orders/{ORDER_ID}/line-items Create line items for an order    //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/line-items Update an order's line items       //
  // - GET /{config.API_URL}/orders/{ORDER_ID}/line-items/{lineItemId} Return an order's     //
  //  line item                                                                              //
  // - PUT /{config.API_URL}/orders/{ORDER_ID}/line-items/{lineItemId} Update a line item in //
  //  an order                                                                               //
  // - DELETE /{config.API_URL}/orders/{ORDER_ID}/line-items/{lineItemId} Delete a line item //
  //  from order                                                                             //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const lineItems = {
    put: data => $.ajax({
      type: 'PUT',
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `${config.API_URL}/orders/${getOrderId()}/line-items`,
      data,
    }),
  }

  const lineItem = {
    delete: id => $.ajax({
      type: 'DELETE',
      headers: { checksum: checksum(), Accept: 'application/json;v=1' },
      contentType: 'application/json',
      url: `${config.API_URL}/orders/${getOrderId()}/line-items/${id}`,
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////
  // GeoService                                                                              //
  // - GET /{config.API_URL}/rest/geo/countries Get a list of countries and states/provinces //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const countries = {
    get: () => $.get({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: '/rest/geo/countries',
    }),
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // USPSValidationService                                                                   //
  // - POST /rest/address/scrub?scrubNeeded=Y&appRoute={appRoute} Validate that an           //
  // address is a valid USPS address                                                         //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const usps = {
    post: data => $.post({
      headers: { Accept: 'application/json;v=2' },
      contentType: 'application/json;v=2',
      dataType: 'json',
      url: '/rest/address/scrub?scrubNeeded=Y',
      data,
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////
  // Fulfillment                                                                             //
  // - POST /fulfillment/shipping-options/calculated-available-shipping-options     Gets the //
  // available shipping options (per line item) from the Fulfillment Service.                //
  // NOTE: ?isEadIncluded=true will also return the EAD for the item otherwise -1 is         //
  // returned for EAD (bogus/NA)                                                             //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const fullfillment = {
    post: (data, options) => {
      const params = []
      if (options) {
        Object.keys(options).forEach((element) => {
          params.push(`${element}=${options[element]}`)
        })
      }
      const reqParams = (params.length) ? `?${params.join('&')}` : ''
      return $.post({
        headers: { Accept: 'application/json;v=1' },
        contentType: 'application/json',
        dataType: 'json',
        url: `/order-processing/rest/fulfillment/shipping-options/calculated-available-shipping-options${reqParams}`,
        data,
      })
    },
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // Shipping Charge                                                                         //
  // - POST /rest/shipping/shippingCharge    Get associated shipping charge (and ship group) //
  // information for an order                                                                //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const shippingCharge = {
    post: data => $.post({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: '/rest/shipping/shippingCharge',
      data,
    }),
  }


  // //////////////////////////////////////////////////////////////////////////////////////////
  // User Service                                                                            //
  // - REGISTER /rest/user/register Create a new account from a just placed order            //
  // - LOGOUT /rest/user/logout Logs out a signed in user                                    //
  // //////////////////////////////////////////////////////////////////////////////////////////

  const user = {
    register: (orderId, data) => $.post({
      headers: { Accept: 'application/json;v=2' },
      contentType: 'application/json',
      dataType: 'json',
      url: `/rest/user/register/${orderId}`,
      data: JSON.stringify(data),
    }),
  }

  const giftCard = {
    // GET /rei-wallet/giftcard/public/v2/${cardId}?includeBalance=true
    get: cardId => $.get({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: `/rei-wallet/giftcard/public/v2/${cardId}?includeBalance=true`,
    }),

    // POST /rei-wallet/giftcard/public/v2
    //   number - the gift card number - string
    //   pin - the gift card pin - string
    //   Identity-Token - the secure session token - header - string
    post: data => $.post({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/x-www-form-urlencoded',
      dataType: 'text',
      url: '/rei-wallet/giftcard/public/v2',
      data,
    }),

    // DELETE /rei-wallet/giftcard/public/v2/${cardId}
    //   cardId (required) - the id of the gift card path - integer
    //   Identity-Token - the secure session token - header - string
    delete: cardId => $.ajax({
      method: 'DELETE',
      url: `/rei-wallet/giftcard/public/v2/${cardId}`,
      accept: 'application/json',
      contentType: 'application/json; charset=utf-8',
    }),
  }

  const giftCards = {
    // GET /rei-wallet/giftcard/public/v2?includeBalance=true
    get: () => $.get({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/json',
      dataType: 'json',
      url: '/rei-wallet/giftcard/public/v2?includeBalance=true',
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////
  // Hippo Service                                                                           //
  // - GET <dynamic> Fetches content from the Hippo CMS                                      //
  // //////////////////////////////////////////////////////////////////////////////////////////
  const hippo = {
    get: url => $.get({
      headers: { Accept: 'text/html' },
      contentType: 'text/html',
      url,
    }),
  }

  // /////////////////////////////////////////////////////////////////////////////////////////////
  // Apple Pay                                                                                  //
  // - createSession ${config.API_URL}/create-session    Creates and Apple Pay session with     //
  // REI BE                                                                                     //
  // - submit /{config.API_URL}/orders/{ORDER_ID}/submit-request-ap Submit an Apple Pay order   //
  // /////////////////////////////////////////////////////////////////////////////////////////////

  const applePay = {
    createSession: validationUrl => $.post({
      headers: { Accept: 'application/json;v=1' },
      contentType: 'application/json',
      url: `${config.API_URL}/create-session`,
      dataType: 'json',
      data: JSON.stringify({ validation_url: validationUrl }),
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////
  // Customer Lists                                                                                 //
  // - notifyMe /customer-lists/notify-me    Email to notify when backorder sku is back in stock //
  // //////////////////////////////////////////////////////////////////////////////////////////////////

  const customerLists = {
    notifyMe: data => $.post({
      headers: { Accept: 'application/json' },
      contentType: 'application/json',
      url: '/customer-lists/notify-me',
      dataType: 'json',
      data: JSON.stringify(data),
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////
  // Logs                                                                                            //
  // - log /rest/log    Logs a message to Kibana                                                     //
  // //////////////////////////////////////////////////////////////////////////////////////////////////

  const logs = {
    log: data => $.post({
      headers: { Accept: 'application/json' },
      contentType: 'application/json',
      url: '/rest/log',
      dataType: 'json',
      data: JSON.stringify(data),
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////
  // Availability                                                                                    //
  // - datesByService /availability/rs/ead/dates-by-service    Gets EAD data for a sku               //
  // //////////////////////////////////////////////////////////////////////////////////////////////////

  const availability = {
    post: payload => $.post({
      headers: { Accept: 'application/json' },
      contentType: 'application/json;q=0.9;v=1',
      url: '/fulfillment/delivery-date/ship-info',
      dataType: 'json',
      data: JSON.stringify(payload),
    }),
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////
  // OrderDetails                                                                                    //
  // - get /rest/orders/${orderId}:by-fulfillment?    Gets an order for a given orderId, last name   //
  // and zip code                                                                                    //
  // //////////////////////////////////////////////////////////////////////////////////////////////////

  const orderDetails = {
    get: ({ orderId, lastName, zipCode }) => $.get({
      headers: { Accept: 'application/json' },
      url: `/rest/orders/${orderId}:by-fulfillment?lastName=${lastName}&zipCode=${zipCode}&isRetailPurchase=false`,
    }),
  }


  // ////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Authentication                                                                                        //
  // - POST /authentication-api/rs/member-lookup    Send the user's information along to generate an email //
  // with their member number if there is a match                                                          //
  // ////////////////////////////////////////////////////////////////////////////////////////////////////////

  const authentication = {
    post: data => $.post({
      headers: { Accept: 'application/json' },
      contentType: 'application/json',
      url: '/authentication-api/rs/member-lookup',
      dataType: 'json',
      data: JSON.stringify(data),
    }),
  }

  const customerAttributes = {
    get: mcvId => $.get({
      headers: { Accept: 'application/json' },
      contentType: 'application/json',
      dataType: 'json',
      url: `/customer-analytics-attributes/rs/customer/visitors/${mcvId}`,
    }),
  }


  return {
    applePay,
    authentication,
    cart,
    customer,
    customerAttributes,
    billingAddress,
    countries,
    coupon,
    coupons,
    fullfillment,
    giftCard,
    giftCards,
    hippo,
    lineItem,
    lineItems,
    order,
    orderDetails,
    customerLists,
    logs,
    availability,
    shippingCharge,
    stores,
    submit,
    tender,
    tenders,
    user,
    usps,
  }
})()
